define(['text!../templates/youtube.html'],
    (templateStr) => {
        return ['$sce', $sce => {
            return {
                restrict: 'AE',
                scope: {videoId: '@'},
                replace: true,
                template: templateStr,
                link: scope => {
                    scope.$watch('videoId', videoId => {
                        if (videoId) {
                            scope.url = $sce.trustAsResourceUrl(`http://www.youtube.com/embed/${videoId}`);
                        }
                    });
                }
            };
        }];
    });



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/youtube/directives/Youtube.js